export const NOTIFICATION_TABS = [
  { id: "all", label: "All", icon: "bi bi-inbox" },
  { id: "unread", label: "Unread", icon: "bi bi-envelope" },
  { id: "read", label: "Read", icon: "bi bi-envelope-check" },
];

export function normalizeNotification(item) {
  if (!item || typeof item !== "object") return null;
  return {
    id: item.id,
    title: item.title ?? item.name ?? "—",
    description: item.description ?? item.body ?? "",
    isRead: item.isRead ?? item.read ?? false,
    icon: item.icon ?? "bi bi-file-earmark-text",
    client: item.client ?? null,
    supplier: item.supplier ?? null,
    created:
      item.created ?? item.createdAt ?? item.date ?? new Date().toISOString(),
    route: item.route ?? item.path ?? null,
  };
}

export function getTabsWithCounts({ listLength, unreadLength, readLength }) {
  return NOTIFICATION_TABS.map((tab) => ({
    ...tab,
    label:
      tab.id === "all"
        ? `All (${listLength})`
        : tab.id === "unread"
          ? `Unread (${unreadLength})`
          : `Read (${readLength})`,
  }));
}
